import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AppShell from './components/layout/AppShell';
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import LoginPage from './pages/auth/LoginPage';
import FleetPage from './pages/fleet/FleetPage';
import VesselDetailPage from './pages/fleet/VesselDetailPage';
import InspectionsPage from './pages/inspections/InspectionsPage';
import ConductInspectionPage from './pages/inspections/ConductInspectionPage';
import QuestionnairePage from './pages/questionnaire/QuestionnairePage';
import ReportsPage from './pages/reports/ReportsPage';
import CAPAPage from './pages/capa/CAPAPage';
import FleetTrackingPage from './pages/capa/FleetTrackingPage';
import AnalyticsPage from './pages/analytics/AnalyticsPage';
import NotificationsPage from './pages/notifications/NotificationsPage';
import SettingsPage from './pages/settings/SettingsPage';
import ContactPage from './pages/contact/ContactPage';
import { useAppStore } from './store/useAppStore';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAppStore();
  if (!isAuthenticated) return <Navigate to="/" replace />;
  return <>{children}</>;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/landing" element={<Navigate to="/" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/app" element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="fleet" element={<FleetPage />} />
          <Route path="fleet/:id" element={<VesselDetailPage />} />
          <Route path="inspections" element={<InspectionsPage />} />
          <Route path="inspections/conduct" element={<ConductInspectionPage />} />
          <Route path="questionnaires" element={<QuestionnairePage />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="capa" element={<CAPAPage />} />
          <Route path="capa/fleet-tracking" element={<FleetTrackingPage />} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="settings/company" element={<SettingsPage section="company" />} />
          <Route path="settings/users" element={<SettingsPage section="users" />} />
          <Route path="settings/security" element={<SettingsPage section="security" />} />
          <Route path="settings/integrations" element={<SettingsPage section="integrations" />} />
          <Route path="help" element={<SettingsPage section="company" />} />
          <Route path="*" element={<Navigate to="/app" replace />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
